import React, { useEffect, useState, useRef } from "react";

import { GameContextProvider, GameContext } from "./Context/Context";
import { useParams } from "react-router-dom";

import GameBanner from "./Banner";
import GameBoard from "./Board";

import GameScoreboard from "./Scoreboard";
import GameTallyBoard from "./TallyBoard";
import NotFound from "../NotFound";
import { FetchResult } from "../../services/GameService";
import GameLoading from "./Loading";
import { GameState } from "../../types/GameTypes";
import { useEngine } from "./Engine/EngineHook";

import "./Game.scss";

function Game() {
  const engine = useEngine();

  const [{ loading }, setFetchGameResults] = useState<FetchResult<GameState>>({
    loading: false,
  });

  const { nonce } = useParams<{ nonce: string }>();

  const refEngine = useRef(engine); // ref so that we avoid a useEffect endless loop

  useEffect(() => {
    if (nonce) {
      refEngine.current.loadGame(nonce, setFetchGameResults);
    }
  }, [nonce, refEngine]);

  const gameContextValue: GameContext = {
    engine,
  };

  return (
    <>
      {loading ? (
        <GameLoading />
      ) : (
        <>
          {engine.isVoid() ? (
            <NotFound />
          ) : (
            <GameContextProvider value={gameContextValue}>
              {engine.getNonce() && (
                <div className={`game-layout game-${engine.getState().toLowerCase()}`}>
                  <GameBanner />
                  <GameBoard />
                  {engine.isRunning() ? <GameScoreboard /> : <GameTallyBoard />}
                </div>
              )}
            </GameContextProvider>
          )}
        </>
      )}
    </>
  );
}

export default Game;
